<script>
import * as moment from "moment";
export default {
  name: "CalendarSelector",
  props: {
    undeliveredList: {
      required: true,
      type: Array
    },
    dates: {
      type: Array
    }
  },
  data() {
    return {
      attrs: [
        {
          key: "selectDate",
          highlight: {
            backgroundColor: "#fb6e6b",
            width: "22px",
            height: "22px"
          },
          contentStyle: {
            color: "#fff"
          },
          dates: [""],
          excludeDates: {
            days: []
          }
        },
        {
          contentStyle: {
            opacity: "0.2"
          },
          dates: { days: [] }
        },
        {
          dot: {
            backgroundColor: "#fb6e6b",
            diameter: "12px"
          },
          dates: {
            days: []
          }
        }
      ],
      themeStyles: {
        wrapper: {
          background: "none",
          border: "0px",
          padding: "0 1.5rem 0 4rem"
        },
        dayCellNotInMonth: {
          opacity: 0
        },
        headerArrows: {
          margin: "10px"
        },
        dayCell: {
          fontSize: "13px",
          border: "0.5px solid #d8d8d8",
          color: "#4a4a4a"
        },
        weekdaysHorizontalDivider: {
          padding: "2rem"
        }
      },
      disableDay: [],
      currentPage: null,
      currentPageDate: { month: null, year: null },
      weeklyArr: [false, false, false, false, false],
      weekSerialArr: []
    };
  },
  methods: {
    sortDate(data) {
      return data.sort((a, b) => {
        let aa = a.split("-");
        let bb = b.split("-");
        return aa[0] - bb[0] || aa[1] - bb[1] || aa[2] - bb[2];
      });
    },
    checkDay(dayArray, selectedDay) {
      return dayArray.find(day => {
        return day === selectedDay;
      });
    },
    arrangeDates(dates) {
      dates = dates.map(
        day =>
          `${this.currentPageDate.year}-${this.currentPageDate.month}-${day}`
      );
      dates = this.sortDate(dates);
      dates = Array.from(new Set(dates));
      this.$emit("getCurrentPage", this.currentPageDate);
      return dates;
    },
    createOrderByEmitDates(dates) {
      let emitDate = this.arrangeDates(dates);
      this.$emit("getDates", emitDate);
    },
    removeDatesToOrder(dates) {
      let emitDate = this.arrangeDates(dates);
      this.$emit("removeDates", emitDate);
    },
    removeDay(dayArray, selectedDay) {
      let selectedDayIndex = dayArray.indexOf(
        `${this.currentPageDate.year}-${
          this.currentPageDate.month
        }-${selectedDay}`
      );
      dayArray.splice(selectedDayIndex, 1);
    },
    dayclick(event) {
      if (this.currentPageDate.month !== event.month) return;
      let disable = this.disableDay.some(day => day === event.day);
      if (disable) return;
      let selectedDay = `${event.year}-${event.month}-${event.day}`;
      let { dates } = this.attrs[0];
      //;

      if (this.checkDay(dates, selectedDay)) {
        if (confirm("刪除日期當日訂單也會跟著刪除，確定刪除日期？")) {
          //this.removeDay(dates, selectedDay);
          this.$emit("getCurrentPage", this.currentPageDate);
          this.$emit("removeDate", selectedDay);
        }
        return;
      }

      dates.push(selectedDay);
      dates = Array.from(new Set(dates));
      this.$emit("getCurrentPage", this.currentPageDate);
      this.$emit("getDate", selectedDay);
    },
    calcWeekSerialCheckboxNum(page) {
      let weekSerialArr = [];
      let weekNum = page.monthComps.weeks;
      this.weekNum = weekNum;
      for (var i = 0; i < weekNum; i++) {
        weekSerialArr.push(false);
      }
      this.weekSerialArr = weekSerialArr;
    },
    pageChange(page) {
      this.currentPageDate.year = page.year;
      this.currentPageDate.month = page.month;
      this.disableAgoDays();
      this.calcWeekSerialCheckboxNum(page); // 動態計算左側 checkbox 數量
      //this.attrs[0].dates.days = []; //Init 日期
      this.attrs[1].dates.days = this.disableDay; //Init 日期
      this.weeklyArr = [false, false, false, false, false]; //Init weekday checkbox
      //this.createOrderByEmitDates();
      this.$emit("getCurrentPage", this.currentPageDate);
    },
    getWeekDayArr(nowYear, nowMonth, weekday) {
      let weekdayInFirstWeek = moment(`${nowYear}-${nowMonth}`)
        .startOf("month")
        .day(weekday);
      //以週一為例，確認該月一號的週一
      if (weekdayInFirstWeek.date() > 7) weekdayInFirstWeek.add(7, "d");
      //如果日期大於 7，則確定週一為上個月的日期。則日期加七，就為該月第一週的週一
      let weekDayArr = [];
      var targetMonth = weekdayInFirstWeek.month();
      while (targetMonth === weekdayInFirstWeek.month()) {
        // weekdayInFirstWeek加一週，直到月份不為該月月份就停止迴圈
        weekDayArr.push(weekdayInFirstWeek.date());
        weekdayInFirstWeek.add(7, "d");
        //取得下週一日期
      }
      return weekDayArr;
    },
    clickWeekdayCheckbox(event, weekday) {
      let weekArr = this.getWeekDayArr(
        this.currentPageDate.year,
        this.currentPageDate.month,
        weekday + 1
      );
      let { dates } = this.attrs[0];
      this.disableDay.forEach(day => {
        weekArr = weekArr.filter(weekDay => {
          return weekDay !== day;
        });
      });
      //得到 weekday 所有日期

      if (this.weeklyArr[weekday]) {
        if (confirm("刪除日期當日訂單也會跟著刪除，確定刪除日期？")) {
          // 如果 checkbox 被勾選
          weekArr.forEach(targetDay => {
            this.removeDay(dates, targetDay);
          }); // 剔除重複的日期
          this.removeDatesToOrder(weekArr);
          return;
        }
        event.target.checked = true;
        return;
      }
      weekArr.forEach(targetDay => {
        dates.push(
          `${this.currentPageDate.year}-${
            this.currentPageDate.month
          }-${targetDay}`
        );
      }); // 不然就加入 weekday 日期
      this.createOrderByEmitDates(weekArr);
      this.attrs[0].dates = Array.from(new Set(dates));
      this.sortDate(this.attrs[0].dates);
    },
    calcRangeDateofWeek(WeekSerialNum) {
      let year = this.currentPageDate.year;
      let month = this.currentPageDate.month;
      var startDateOfWeek =
        moment(`${year}-${month}-01`)
          .startOf("week")
          .add(WeekSerialNum, "week")
          .date() + 1;
      var endDateOfWeek =
        moment(`${year}-${month}-01`)
          .endOf("week")
          .add(WeekSerialNum, "week")
          .date() - 1;
      var endDateOfMonth = moment(`${year}-${month}`)
        .endOf("month")
        .date();
      if (startDateOfWeek > 7 && WeekSerialNum === 0) {
        //第一週的第一天如果是上個月的日期 就改為1
        startDateOfWeek = 1;
      }
      if (endDateOfWeek < 6 && WeekSerialNum !== 0) {
        //最後一週的最後一天如果是下個月的日期就改為當月最後一天
        endDateOfWeek = endDateOfMonth;
      }

      return {
        startDate: startDateOfWeek,
        endDate: endDateOfWeek
      };
    },
    clickWeekSerialCheckbox(event, weekSerialNum) {
      let rangeDate = this.calcRangeDateofWeek(weekSerialNum); // 計算當週日期範圍

      let { dates } = this.attrs[0];
      let weekArr = [];

      while (rangeDate.startDate <= rangeDate.endDate) {
        //push當週日期
        weekArr.push(rangeDate.startDate);
        rangeDate.startDate += 1;
      }
      this.disableDay.forEach(day => {
        weekArr = weekArr.filter(weekDay => {
          return weekDay !== day;
        });
      });

      if (rangeDate.startDate === rangeDate.endDate) {
        //如果當週只有一天
        let index = dates.indexOf(rangeDate.startDate);
        //已勾選就刪除值，未勾選就增加值

        this.weekSerialArr[weekSerialNum]
          ? dates.push(rangeDate.startDate)
          : dates.splice(index, 1);
        return;
      }

      if (this.weekSerialArr[weekSerialNum]) {
        if (confirm("刪除日期當日訂單也會跟著刪除，確定刪除日期？")) {
          weekArr.forEach(targetDay => {
            this.removeDay(dates, targetDay);
          });
          this.removeDatesToOrder(weekArr);
          return;
        }
        event.target.checked = true;
        return;
      }
      weekArr.forEach(targetDay => {
        dates.push(
          `${this.currentPageDate.year}-${
            this.currentPageDate.month
          }-${targetDay}`
        );
      });
      this.createOrderByEmitDates(weekArr);
      this.attrs[0].dates = Array.from(new Set(dates));
      this.sortDate(this.attrs[0].dates);
    },
    initWeekSerialCheckbox(nowYear, nowMonth) {
      let firstWeek = moment(`${nowYear}-${nowMonth}`)
        .startOf("month")
        .week();
      let lastWeek = moment(`${nowYear}-${nowMonth}`)
        .endOf("month")
        .week();

      let weekNum;
      let weekSerialArr = [];
      lastWeek === 1
        ? (weekNum = 54 - firstWeek)
        : (weekNum = lastWeek - firstWeek + 1);

      Array.from({ length: weekNum }, () => weekSerialArr.push(false));

      this.weekSerialArr = weekSerialArr;
    },
    disableAgoDays() {
      let nowYear = moment().format("YYYY");
      let nowMonth = moment().format("MM");
      let sunday = this.getWeekDayArr(
        this.currentPageDate.year,
        this.currentPageDate.month,
        0
      );
      let saturday = this.getWeekDayArr(
        this.currentPageDate.year,
        this.currentPageDate.month,
        6
      );
      let lastDay = moment(
        `${this.currentPageDate.year}-${this.currentPageDate.month}`
      ).daysInMonth();
      let days = [];

      if (
        this.currentPageDate.year < nowYear ||
        (this.currentPageDate.year == nowYear &&
          this.currentPageDate.month < nowMonth)
      ) {
        days = Array.from({ length: lastDay }, (item, index) => index + 1);
      }
      if (
        this.currentPageDate.year == nowYear &&
        this.currentPageDate.month == nowMonth
      ) {
        let now = moment().date();
        days = Array.from({ length: now - 1 }, (item, index) => index + 1);
      }
      let nowTime = moment().format("HH");
      if (nowTime > 16 && Number(this.currentPageDate.month) == nowMonth) {
        days.push(Number(moment().format("DD")));
      }
      sunday.forEach(day => days.push(day));
      saturday.forEach(day => days.push(day));
      days = Array.from(new Set(days));

      this.disableDay = days;
      this.attrs[1].dates.days = days;
      this.attrs[0].excludeDates.days = days;
    },
    calendarDateInit() {
      let nowYear = moment().format("YYYY");
      let nowMonth = moment().format("MM");
      this.currentPageDate.month = Number(nowMonth);
      this.currentPageDate.year = Number(nowYear);
      this.$emit("getCurrentPage", this.currentPageDate);
      this.initWeekSerialCheckbox(nowYear, nowMonth);
      this.disableAgoDays();
      this.attrs[2].dates.days = this.undeliveredList;
    }
  },
  mounted() {
    this.calendarDateInit();
  },
  watch: {
    dateList(val) {
      this.attrs[0].dates.days = val;
    },
    dates(val) {
      if (val.length === 0) {
        this.attrs[0].dates = [""];
        return;
      }
      this.attrs[0].dates = val;
    },
    currentPage: {
      handler(val) {
        this.currentPage = val;
      },
      deep: true
    },
    undeliveredList: {
      handler(val) {
        this.attrs[2].dates.days = val;
      },
      deep: true
    }
  }
};
</script>

<template src="./template.html"></template>
<style lang="scss" src="./style.scss" scoped />
